module.exports = __webpack_public_path__ + "img/visualisierung large outside.2a9f44ab.jpg";